import { Component } from '@angular/core';
import { PersonsListComponent } from './persons-list/persons-list.component';

@Component({
  selector: 'app-persons',
  standalone: true,
  imports: [PersonsListComponent],
  templateUrl: './persons.component.html',
  styleUrl: './persons.component.scss',
})
export class PersonsComponent {}
